import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button, Select, MenuItem} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography'; 
import TagsOptions from '../components/TagsOptions';
import AutocompleteTreeviewTemp from '../components/AutocompleteTreeviewTemp';
import AutocompleteTT from '../components/AutocompleteTT';
import axios from 'axios';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const userObj = useSelector(state => state.userDetails);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);

  const [checkedSelfTestTopicTreeview, setCheckedSelfTestTopicTreeview] = React.useState(true);
  const [checkedSelfTestTopicList, setCheckedSelfTestTopicList] = React.useState(true);
  const [checkedSelfTestKeywordsList, setCheckedSelfTestKeywordsList] = React.useState(true);
  const [checkedStudyMaterialTopicTreeview, setCheckedStudyMaterialTopicTreeview] = React.useState(true);
  const [checkedStudyMaterialTopicList, setCheckedStudyMaterialTopicList] = React.useState(true);
  const [checkedStudyMaterialKeywordsList, setCheckedStudyMaterialKeywordsList] = React.useState(true);
  const [checkedStudyMaterialDefaultContent, setCheckedStudyMaterialDefaultContent] = React.useState(true);
  const [checkedTopicTestTopicTreeview, setCheckedTopicTestTopicTreeview] = React.useState(true);
  const [checkedTopicTestTopicList, setCheckedTopicTestTopicList] = React.useState(true);
  const [checkedMockTestList, setCheckedMockTestList] = React.useState(true);

  const [checkedSelfTestTopicTreeviewDel, setCheckedSelfTestTopicTreeviewDel] = React.useState(false);
  const [checkedSelfTestTopicListDel, setCheckedSelfTestTopicListDel] = React.useState(false);
  const [checkedSelfTestKeywordsListDel, setCheckedSelfTestKeywordsListDel] = React.useState(false);
  const [checkedStudyMaterialTopicTreeviewDel, setCheckedStudyMaterialTopicTreeviewDel] = React.useState(false);
  const [checkedStudyMaterialTopicListDel, setCheckedStudyMaterialTopicListDel] = React.useState(false);
  const [checkedStudyMaterialKeywordsListDel, setCheckedStudyMaterialKeywordsListDel] = React.useState(false);
  const [checkedStudyMaterialDefaultContentDel, setCheckedStudyMaterialDefaultContentDel] = React.useState(false);
  const [checkedTopicTestTopicTreeviewDel, setCheckedTopicTestTopicTreeviewDel] = React.useState(false);
  const [checkedTopicTestTopicListDel, setCheckedTopicTestTopicListDel] = React.useState(false);
  const [checkedMockTestListDel, setCheckedMockTestListDel] = React.useState(false);
  
 
  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  
  React.useEffect(() => {	
    setSaveLoading(false);
    // setCheckedSelfTestTopicTreeview(true);
    // setCheckedSelfTestTopicList(true);
    // setCheckedSelfTestKeywordsList(true);
    // setCheckedStudyMaterialTopicTreeview(true);
    // setCheckedStudyMaterialTopicList(true);
    // setCheckedStudyMaterialKeywordsList(true);
    // setCheckedStudyMaterialDefaultContent(true);
    // setCheckedTopicTestTopicTreeview(true);
    // setCheckedTopicTestTopicList(true);
    // setCheckedMockTestList(true);

    setCheckedSelfTestTopicTreeviewDel(false);
    setCheckedSelfTestTopicListDel(false);
    setCheckedSelfTestKeywordsListDel(false);
    setCheckedStudyMaterialTopicTreeviewDel(false);
    setCheckedStudyMaterialTopicListDel(false);
    setCheckedStudyMaterialKeywordsListDel(false);
    setCheckedStudyMaterialDefaultContentDel(false);
    setCheckedTopicTestTopicTreeviewDel(false);
    setCheckedTopicTestTopicListDel(false);
    setCheckedMockTestListDel(false);

	}, [open]);

  function handleClear(){
    setCheckedSelfTestTopicTreeview(false);
    setCheckedSelfTestTopicList(false);
    setCheckedSelfTestKeywordsList(false);
    setCheckedStudyMaterialTopicTreeview(false);
    setCheckedStudyMaterialTopicList(false);
    setCheckedStudyMaterialKeywordsList(false);
    setCheckedStudyMaterialDefaultContent(false);
    setCheckedTopicTestTopicTreeview(false);
    setCheckedTopicTestTopicList(false);
    setCheckedMockTestList(false);

    setCheckedSelfTestTopicTreeviewDel(false);
    setCheckedSelfTestTopicListDel(false);
    setCheckedSelfTestKeywordsListDel(false);
    setCheckedStudyMaterialTopicTreeviewDel(false);
    setCheckedStudyMaterialTopicListDel(false);
    setCheckedStudyMaterialKeywordsListDel(false);
    setCheckedStudyMaterialDefaultContentDel(false);
    setCheckedTopicTestTopicTreeviewDel(false);
    setCheckedTopicTestTopicListDel(false);
    setCheckedMockTestListDel(false);
  }

  function handleCheckAll(){
    setCheckedSelfTestTopicTreeview(true);
    setCheckedSelfTestTopicList(true);
    setCheckedSelfTestKeywordsList(true);
    setCheckedStudyMaterialTopicTreeview(true);
    setCheckedStudyMaterialTopicList(true);
    setCheckedStudyMaterialKeywordsList(true);
    setCheckedStudyMaterialDefaultContent(true);
    setCheckedTopicTestTopicTreeview(true);
    setCheckedTopicTestTopicList(true);
    setCheckedMockTestList(true);
  }

	function saveData(){    
        
		if(checkedSelfTestTopicTreeview===true || checkedSelfTestTopicList===true || checkedSelfTestKeywordsList===true || checkedStudyMaterialTopicTreeview===true || checkedStudyMaterialTopicList===true || checkedStudyMaterialKeywordsList===true || checkedStudyMaterialDefaultContent===true || checkedTopicTestTopicTreeview===true || checkedTopicTestTopicList===true || checkedMockTestList===true || checkedSelfTestTopicTreeviewDel===true || checkedSelfTestTopicListDel===true || checkedSelfTestKeywordsListDel===true || checkedStudyMaterialTopicTreeviewDel===true || checkedStudyMaterialTopicListDel===true || checkedStudyMaterialKeywordsListDel===true || checkedStudyMaterialDefaultContentDel===true || checkedTopicTestTopicTreeviewDel===true || checkedTopicTestTopicListDel===true || checkedMockTestListDel===true){ 

      setSaveLoading(true);

			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'	
				}
			}; 
			const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('templateId', props.dataObj.autoId);
      }

      if(checkedSelfTestTopicTreeview===true){
        data.append('selfTestTopicTreeviewOption', 1);
      }else if(checkedSelfTestTopicTreeviewDel===true){
        data.append('selfTestTopicTreeviewOption', 2);        
      }else{
        data.append('selfTestTopicTreeviewOption', 0);
      }

      if(checkedSelfTestTopicList===true){
        data.append('selfTestTopicListOption', 1);
      }else if(checkedSelfTestTopicListDel===true){
        data.append('selfTestTopicListOption', 2);        
      }else{
        data.append('selfTestTopicListOption', 0);
      }

      if(checkedSelfTestKeywordsList===true){
        data.append('selfTestKeywordsListOption', 1);
      }else if(checkedSelfTestKeywordsListDel===true){
        data.append('selfTestKeywordsListOption', 2);  
      }else{
        data.append('selfTestKeywordsListOption', 0);
      }

      if(checkedStudyMaterialTopicTreeview===true){
        data.append('studyMaterialTopicTreeviewOption', 1);
      }else if(checkedStudyMaterialTopicTreeviewDel===true){
        data.append('studyMaterialTopicTreeviewOption', 2);  
      }else{
        data.append('studyMaterialTopicTreeviewOption', 0);
      }

      if(checkedStudyMaterialTopicList===true){
        data.append('studyMaterialTopicListOption', 1);
      }else if(checkedStudyMaterialTopicListDel===true){
        data.append('studyMaterialTopicListOption', 2);  
      }else{
        data.append('studyMaterialTopicListOption', 0);
      }

      if(checkedStudyMaterialKeywordsList===true){
        data.append('studyMaterialKeywordsListOption', 1);
      }else if(checkedStudyMaterialKeywordsListDel===true){
        data.append('studyMaterialKeywordsListOption', 2);  
      }else{
        data.append('studyMaterialKeywordsListOption', 0);
      }

      if(checkedStudyMaterialDefaultContent===true){
        data.append('studyMaterialDefaultContentOption', 1);
      }else if(checkedStudyMaterialDefaultContentDel===true){
        data.append('studyMaterialDefaultContentOption', 2);  
      }else{
        data.append('studyMaterialDefaultContentOption', 0);
      }

      if(checkedTopicTestTopicTreeview===true){
        data.append('topicTestTopicTreeviewOption', 1);
      }else if(checkedTopicTestTopicTreeviewDel===true){
        data.append('topicTestTopicTreeviewOption', 2);  
      }else{
        data.append('topicTestTopicTreeviewOption', 0);
      }

      if(checkedTopicTestTopicList===true){
        data.append('topicTestTopicListOption', 1);
      }else if(checkedTopicTestTopicListDel===true){
        data.append('topicTestTopicListOption', 2);  
      }else{
        data.append('topicTestTopicListOption', 0);
      }

      if(checkedMockTestList===true){
        data.append('mockTestListOption', 1);
      }else if(checkedMockTestListDel===true){
        data.append('mockTestListOption', 2);  
      }else{
        data.append('mockTestListOption', 0);
      }
      
             
			axios.post(env.API_URL+'/exams/examtemplate-cache-updates', data, axiosHeader)
			.then((response) => {
        setSaveLoading(false);
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("Cache has been updated");
          props.reloadList(true);	
					return false;
				}else if(response.data.responseTxt==="DataNotFound"){
					setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Data not found to update cache");
					return false;	
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Cache could not be updated.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("ERROR: ", error);
			})	
		}else{
      setSeverityAlert("error");
			setShowAlert(true);
			setAlertMessage("Check any one");
			return false;
    }		
	}

  function handleCheckedSelfTestTopicTreeview(chk){
    setCheckedSelfTestTopicTreeview(chk);
    if(chk===true){
      setCheckedSelfTestTopicTreeviewDel(false);
    }
  }
  function handleCheckedSelfTestTopicTreeviewDel(chk){
    setCheckedSelfTestTopicTreeviewDel(chk);
    if(chk===true){
      setCheckedSelfTestTopicTreeview(false);
    }
  }
  
  function handleCheckedSelfTestTopicList(chk){
    setCheckedSelfTestTopicList(chk);
    if(chk===true){
      setCheckedSelfTestTopicListDel(false);
    }
  }
  function handleCheckedSelfTestTopicListDel(chk){
    setCheckedSelfTestTopicListDel(chk);
    if(chk===true){
      setCheckedSelfTestTopicList(false);
    }
  }

  function handleCheckedSelfTestKeywordsList(chk){
    setCheckedSelfTestKeywordsList(chk);
    if(chk===true){
      setCheckedSelfTestKeywordsListDel(false);
    }
  }
  function handleCheckedSelfTestKeywordsListDel(chk){
    setCheckedSelfTestKeywordsListDel(chk);
    if(chk===true){
      setCheckedSelfTestKeywordsList(false);
    }
  }
  
  function handleCheckedStudyMaterialTopicTreeview(chk){
    setCheckedStudyMaterialTopicTreeview(chk);
    if(chk===true){
      setCheckedStudyMaterialTopicTreeviewDel(false);
    }
  }
  function handleCheckedStudyMaterialTopicTreeviewDel(chk){
    setCheckedStudyMaterialTopicTreeviewDel(chk);
    if(chk===true){
      setCheckedStudyMaterialTopicTreeview(false);
    }
  }

  function handleCheckedStudyMaterialTopicList(chk){
    setCheckedStudyMaterialTopicList(chk);
    if(chk===true){
      setCheckedStudyMaterialTopicListDel(false);
    }
  }
  function handleCheckedStudyMaterialTopicListDel(chk){
    setCheckedStudyMaterialTopicListDel(chk);
    if(chk===true){
      setCheckedStudyMaterialTopicList(false);
    }
  }
  
  function handleCheckedStudyMaterialKeywordsList(chk){
    setCheckedStudyMaterialKeywordsList(chk);
    if(chk===true){
      setCheckedStudyMaterialKeywordsListDel(false);
    }
  }
  function handleCheckedStudyMaterialKeywordsListDel(chk){
    setCheckedStudyMaterialKeywordsListDel(chk);
    if(chk===true){
      setCheckedStudyMaterialKeywordsList(false);
    }
  }
  
  function handleCheckedStudyMaterialDefaultContent(chk){
    setCheckedStudyMaterialDefaultContent(chk);
    if(chk===true){
      setCheckedStudyMaterialDefaultContentDel(false);
    }
  }
  function handleCheckedStudyMaterialDefaultContentDel(chk){
    setCheckedStudyMaterialDefaultContentDel(chk);
    if(chk===true){
      setCheckedStudyMaterialDefaultContent(false);
    }
  }

  function handleCheckedTopicTestTopicTreeview(chk){
    setCheckedTopicTestTopicTreeview(chk);
    if(chk===true){
      setCheckedTopicTestTopicTreeviewDel(false);
    }
  }
  function handleCheckedTopicTestTopicTreeviewDel(chk){
    setCheckedTopicTestTopicTreeviewDel(chk);
    if(chk===true){
      setCheckedTopicTestTopicTreeview(false);
    }
  }

  function handleCheckedTopicTestTopicList(chk){
    setCheckedTopicTestTopicList(chk);
    if(chk===true){
      setCheckedTopicTestTopicListDel(false);
    }
  }
  function handleCheckedTopicTestTopicListDel(chk){
    setCheckedTopicTestTopicListDel(chk);
    if(chk===true){
      setCheckedTopicTestTopicList(false);
    }
  }
  
  function handleCheckedMockTestList(chk){
    setCheckedMockTestList(chk);
    if(chk===true){
      setCheckedMockTestListDel(false);
    }
  }
  function handleCheckedMockTestListDel(chk){
    setCheckedMockTestListDel(chk);
    if(chk===true){
      setCheckedMockTestList(false);
    }
  }
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>Update Cache: {props.dataObj?.templateTitle}</h3></div>
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Module</td>
                            <td width={80}>Create / Update</td> 
                            <td width={80}>Delete</td>                           
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td width={200}>Topic Treeview (Self-Test)</td>
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedSelfTestTopicTreeview} onChange={(event) => {handleCheckedSelfTestTopicTreeview(event.target.checked)}} />}
                              />  
                            </td>  
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedSelfTestTopicTreeviewDel} onChange={(event) => {handleCheckedSelfTestTopicTreeviewDel(event.target.checked)}} />}
                              />  
                            </td>                           
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Topic List (Self-Test)</td>
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedSelfTestTopicList} onChange={(event) => {handleCheckedSelfTestTopicList(event.target.checked)}} />}
                              />  
                            </td>  
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedSelfTestTopicListDel} onChange={(event) => {handleCheckedSelfTestTopicListDel(event.target.checked)}} />}
                              />  
                            </td>                           
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Keywords List (Self-Test)</td>
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedSelfTestKeywordsList} onChange={(event) => {handleCheckedSelfTestKeywordsList(event.target.checked)}} />}
                              />  
                            </td> 
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedSelfTestKeywordsListDel} onChange={(event) => {handleCheckedSelfTestKeywordsListDel(event.target.checked)}} />}
                              />  
                            </td>                           
                        </tr>

                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Topic Treeview (Study Material)</td>
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedStudyMaterialTopicTreeview} onChange={(event) => {handleCheckedStudyMaterialTopicTreeview(event.target.checked)}} />}
                              />  
                            </td> 
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedStudyMaterialTopicTreeviewDel} onChange={(event) => {handleCheckedStudyMaterialTopicTreeviewDel(event.target.checked)}} />}
                              />  
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Topic List (Study Material)</td>
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedStudyMaterialTopicList} onChange={(event) => {handleCheckedStudyMaterialTopicList(event.target.checked)}} />}
                              />  
                            </td>  
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedStudyMaterialTopicListDel} onChange={(event) => {handleCheckedStudyMaterialTopicListDel(event.target.checked)}} />}
                              />  
                            </td>                           
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Keywords List (Study Material)</td>
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedStudyMaterialKeywordsList} onChange={(event) => {handleCheckedStudyMaterialKeywordsList(event.target.checked)}} />}
                              />
                            </td> 
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedStudyMaterialKeywordsListDel} onChange={(event) => {handleCheckedStudyMaterialKeywordsListDel(event.target.checked)}} />}
                              />
                            </td>                           
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Default Content (Study Material)</td>
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedStudyMaterialDefaultContent} onChange={(event) => {handleCheckedStudyMaterialDefaultContent(event.target.checked)}} />}
                              />  
                            </td> 
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedStudyMaterialDefaultContentDel} onChange={(event) => {handleCheckedStudyMaterialDefaultContentDel(event.target.checked)}} />}
                              />  
                            </td>                           
                        </tr>

                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Topic Treeview (Topic-Test)</td>
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedTopicTestTopicTreeview} onChange={(event) => {handleCheckedTopicTestTopicTreeview(event.target.checked)}} />}
                              />  
                            </td> 
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedTopicTestTopicTreeviewDel} onChange={(event) => {handleCheckedTopicTestTopicTreeviewDel(event.target.checked)}} />}
                              />  
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Topic List (Topic-Test)</td>
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedTopicTestTopicList} onChange={(event) => {handleCheckedTopicTestTopicList(event.target.checked)}} />}
                              />  
                            </td>
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedTopicTestTopicListDel} onChange={(event) => {handleCheckedTopicTestTopicListDel(event.target.checked)}} />}
                              />  
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Mock Test List</td>
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedMockTestList} onChange={(event) => {handleCheckedMockTestList(event.target.checked)}} />}
                              />  
                            </td>
                            <td>
                              <FormControlLabel
                                label=""
                                control={<Checkbox checked={checkedMockTestListDel} onChange={(event) => {handleCheckedMockTestListDel(event.target.checked)}} />}
                              />  
                            </td>                            
                        </tr>

                      </table>

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                          <Button onClick={() => {handleClear()}} style={{marginRight:12}} size="small" variant="outlined" >Clear</Button>
                          <Button onClick={() => {handleCheckAll()}} style={{marginRight:12}} size="small" variant="outlined" >Check</Button>
                          {saveLoading?
                          <LoadingButton loading={saveLoading} loadingPosition='start' startIcon={<div style={{marginRight:15}}></div>} size="small" color="primary" variant="outlined"  >Saving...</LoadingButton>
                          :
                          <Button onClick={() => {saveData()}} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Save</Button>
                          }
                      </Box>                        


                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;